/**
 * PaginationRequestModel - Sayfalama için ortak model
 * Tüm API isteklerinde sayfalama parametreleri için kullanılır
 */
export class PaginationRequestModel {
  page = 0;
  numberOfRecord = 10;
  sortColumn = 'ID';
  sortOrder: 'asc' | 'desc' | '' = 'desc';
  flag?: boolean;

  setData(data: Partial<PaginationRequestModel>): void {
    Object.assign(this, data);
  }

  clear(): void {
    this.page = 0;
    this.numberOfRecord = 10;
    this.sortColumn = 'ID';
    this.sortOrder = 'desc';
  }
}
